<template>
  <div class="row">
    <div class="col-md-12 col-lg-12">
      <q-form ref="editForm">
        <c-card title="기본정보" class="cardClassDetailForm" topClass="topcolor-blue">
          <template slot="card-button">
            <q-btn-group outline >
              <c-btn
                v-if="editable"
                :url="saveUrl"
                :isSubmit="isSave"
                :param="assessData"
                :mappingType="mappingType"
                label="저장"
                icon="save"
                @beforeAction="saveData"
                @btnCallback="saveCallback" />
            </q-btn-group>
          </template>
          <template slot="card-detail">
            <div class="col-3">
              <c-vendor
                :editable="editable && !disabled"
                :required="true"
                label="도급업체"
                name="vendorCd"
                v-model="assessData.vendorCd">
              </c-vendor>
            </div>
            <div class="col-5">
              <c-text
                :editable="editable && !disabled"
                :required="true"
                label="공사명"
                name="title"
                v-model="assessData.title">
              </c-text>
            </div>
            <div class="col-2">
              <c-datepicker
                :editable="editable && !disabled"
                label="등록일"
                name="regDt"
                v-model="assessData.regDt">
              </c-datepicker>
            </div>
            <div class="col-2">
              <c-field
                :editable="editable && !disabled"
                type="user" 
                label="담당자"
                name="regUserId"
                v-model="assessData.regUserId" />
            </div>
            <div class="col-12">
              <c-textarea
                :editable="editable && !disabled"
                label="비고"
                :rows="2"
                name="remark"
                v-model="assessData.remark" />
            </div>
          </template>
        </c-card>
      </q-form>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="table"
        title="도급업체 첨부파일 목록"
        :columns="grid.columns"
        :data="assessData.resultList"
        :filtering="false"
        :editable="editable && !disabled"
        :isFullScreen="false"
        :columnSetting="false"
        selection="multiple"
        rowKey="mdmVendorAttachResultId"
      >
        <!-- 버튼 영역 -->
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn label="추가" v-if="editable && !disabled" icon="add" @btnClicked="addAttach" />
            <c-btn label="제외" v-if="editable && !disabled" icon="remove" @btnClicked="deleteAttach" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
  </div>
</template>
<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'vendor-attach-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        mdmVendorAttachId: '',
      }),
    },
  },
  data() {
    return {
      vendorEvaluationKindCdItem: [],
      editable: true,
      saveable: false,
      deleteable: false,
      updateMode: false,
      isSave: false,
      isApproval: false,
      mappingType: 'POST',
      detailUrl: '',
      saveUrl: '',
      insertUrl: '',
      updateUrl: '',
      deleteUrl: '',
      assessData: {
        mdmVendorAttachId: '',
        sysApprovalRequestId: '',
        approvalStatusCd: '',
        vendorCd: '',
        vendorName: '',
        title: '',
        remark: '',
        regUserId: '',
        chgUserId: '',
        regDt: '',
        completeFlag: 'N',
        resultList: [],
        deleteResultList: [],
      },
      grid: {
        merge: [
        ],
        columns: [
          {
            name: 'vendorAttachTypeCd',
            field: 'vendorAttachTypeCd',
            label: '첨부분류',
            align: 'center',
            style: 'width:120px',
            sortable: false,
            required: true,
            type: 'text',
          },
          {
            name: 'remark',
            field: 'remark',
            label: '비고',
            align: 'left',
            style: 'width:300px',
            sortable: false,
            type: 'textarea',
          },
          {
            name: 'attach',
            field: 'attach',
            label: '첨부파일',
            align: 'center',
            style: 'width:200px',
            type: 'attach',
            taskClassCd: 'VENDOR_ATTACH',
            keyText: 'mdmVendorAttachResultId',
            sortable: false,
          }
        ],
        data: [],
        height: '450px'
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    approvalInfo() {
      return {
        sysApprovalRequestId: this.assessData.sysApprovalRequestId, // 결재요청번호
        /**
         * 결재상태코드
         * ASC0000001	결재중
         * ASC0000002	반려
         * ASC9999999	결재완료
         */
        approvalStatusCd: this.assessData.approvalStatusCd, 
        apprEditable: this.assessData.completeFlag === 'N', // 결재버튼 활성화 기준
        param: this.assessData, // 결재 param
        approvalUrl: this.updateUrl, // 결재 url
        isApproval: this.isApproval, // 결재 submit
        approvalTypeCd: 'APTC000011', // 결재유형코드
        approvalParamValue: { // 결재상세화면 파라미터
          mdmVendorAttachId: this.assessData.mdmVendorAttachId,
          isApprContent: true
        },
        approvalRequestName: '도급업체 관련서류 ['+this.assessData.vendorName+']', // 결재요청명 (문서 title)
        approvalConnId: this.assessData.mdmVendorAttachId, // 결재연결용 업무일련번호 (문서 key)
      }
    },
    disabled() {
      return this.assessData.completeFlag === 'Y' 
        || this.assessData.approvalStatusCd === 'ASC0000001'
    },
  },
  watch: {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;

      this.detailUrl = selectConfig.mdm.cim.vendor.attach.get.url;
      this.saveUrl = transactionConfig.mdm.cim.vendor.attach.insert.url
      this.insertUrl = transactionConfig.mdm.cim.vendor.attach.insert.url;
      this.updateUrl = transactionConfig.mdm.cim.vendor.attach.update.url;
      this.deleteUrl = transactionConfig.mdm.cim.vendor.attach.delete.url;

      this.getDetail();
    },
    getDetail() {
      if (this.popupParam.mdmVendorAttachId) {
        this.$http.url = this.$format(this.detailUrl, this.popupParam.mdmVendorAttachId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.assessData = _result.data;
        },);
      } else {
        this.assessData.regUserId = this.$store.getters.user.userId
        this.assessData.regDt = this.$comm.getToday();
      }
    },  
    addAttach() {
      this.assessData.resultList.splice(0, 0, {
        mdmVendorAttachResultId: uid(),  // 도급업체 첨부파일 일련번호
        mdmVendorAttachId: this.popupParam.mdmVendorAttachId,  // 도급업체 첨부파일 일련번호
        vendorAttachTypeCd: null,  // 업체별 첨부파일 구분 코드
        remark: '',  // 업체 첨부파일 비고
        regUserId: this.$store.getters.user.userId,  // 등록자 ID
        editFlag: 'C',
      })
    },
    deleteAttach() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.assessData.deleteResultList = [];
        this.$_.forEach(selectData, item => {
          if (this.$_.findIndex(this.assessData.deleteResultList, { mdmVendorAttachResultId: item.mdmVendorAttachResultId }) === -1
            && item.editFlag !== 'C') {
            this.assessData.deleteResultList.push(item)
          }
          this.assessData.resultList = this.$_.reject(this.assessData.resultList, item);
        })
        this.$refs['table'].$refs['compo-table'].clearSelection();
      }
    },
    saveData() {
      if (this.popupParam.mdmVendorAttachId) {
        this.saveUrl = this.updateUrl;
        this.mappingType = 'PUT';
      } else {
        this.saveUrl = this.insertUrl;
        this.mappingType = 'POST';
      }
      this.$refs['editForm'].validate().then(_result => {
        // 중복체크
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.assessData.regUserId = this.$store.getters.user.userId
              this.assessData.chgUserId = this.$store.getters.user.userId
              
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback(_result) {
      if (this.mappingType == 'POST') {
        this.$set(this.popupParam, 'mdmVendorAttachId', _result.data)
      }
      this.getDetail();
      window.getApp.$emit('APP_REQUEST_SUCCESS');
    },
  }
};
</script>